import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../../_hooks/useClientId';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { KindOfProperty } from './useCharitableGivingQuery';

interface DafYear {
  year: number | null;
  type: number;
}

export interface AccountDTO {
  id: string;
  name: string;
  institution: string | null;
  balance: number;
  donationAmount: number | null;
  donationStartYear: DafYear | null;
  donationEndYear: DafYear | null;
  grantAmount: number | null;
  grantStartYear: DafYear | null;
  grantEndYear: DafYear | null;
  kindOfProperty: KindOfProperty | null;
  fundAccounts: string[];
}

interface FetcherParams {
  clientId: number;
}

export const fetchDafAccounts = async ({ clientId }: FetcherParams): Promise<AccountDTO[]> => {
  return authFetch(
    urlWithParams('/Consumer/CharitableGivingWorkflow/DafAccounts', {
      clientId,
    }),
  );
};

export const useDafAccountsQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.dafAccounts(clientId),

    () => fetchDafAccounts({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
